var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon77Sol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3D6BFA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "559.38,841.75 917,158.4 721.08,229.44 475.69,698.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "363.52,841.75 721.15,158.4 525.22,229.44 279.83,698.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "167.67,841.75 525.29,158.4 329.37,229.44 83.98,698.33  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon77Sol);
export default __webpack_public_path__ + "static/media/favicon-77sol.e6dd27cf97937d0a8cb70c71a212d420.svg";
export { ForwardRef as ReactComponent };